import { DISPLAY } from 'constants/display'

export const BINARY_CHOICE = [DISPLAY.yes, DISPLAY.no].map(label => ({
  label,
  value: label,
  id: label,
}))

export const SAME = 'same'
export const DIFFERENT = 'different'
export const FALLBACK_OPTIONS = [
  { label: 'Same as Automobile Liability', value: SAME, id: SAME },
  { label: 'Different', value: DIFFERENT, id: DIFFERENT },
]

export const SCHEDULED_AUTO = 'Scheduled Auto'
export const ANY_AUTO = 'Any Auto'
export const POLICY_TYPES = [
  { label: SCHEDULED_AUTO, value: SCHEDULED_AUTO },
  { label: ANY_AUTO, value: ANY_AUTO },
]
